var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("div", [
        _c("div", { staticClass: "col-lg-6 mb-5 sk-w-200" }, [
          _c("div", [_c("PuSkeleton", { staticClass: "sk-h-30" })], 1)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-12 sk-mb-30" }, [
          _c("div", [_c("PuSkeleton", { staticClass: "sk-h-50" })], 1)
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3eaf6e83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eaf6e83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomThankYouSkeleton.vue
// module id = null
// module chunks = 